<template>
  <span>
    <b-img
      v-if="isMouCompany == true && isAllowFastTrack == false"
      v-b-tooltip.hover.delay="{ show: 1000, hide: 50 }"
      title="เข้าร่วม Fasttrack"
      id="fasttrack-mou"
      :src="require('@/assets/images/logo/fasttrack/fasttrack_mou.png')"
      alt="Fasttrack icon"
      :style="`max-height: ${iconMaxHeight}`"
    />

    <b-img
      v-if="isMouCompany == true && isAllowFastTrack == true"
      v-b-tooltip.hover.delay="{ show: 1000, hide: 50 }"
      title="เข้าร่วม Fasttrack และยินยอมให้ส่งผู้ประกอบธุรกิจ"
      :src="require('@/assets/images/logo/fasttrack/fasttrack_mou_allow.png')"
      id="fasttrack-mou-allow"
      alt="Fasttrack icon"
      class="fast-track-icon"
      :style="`max-height: ${iconMaxHeight}`"
    />
  </span>
</template>
<script>
import { BImg, VBTooltip } from "bootstrap-vue";

export default {
  components: {
    BImg,
  },
  directives: { "b-tooltip": VBTooltip },
  props: {
    isMouCompany: {
      type: Boolean,
      default: false,
    },
    isAllowFastTrack: {
      type: Boolean,
      default: false,
    },
    iconMaxHeight: {
      type: String,
      default: "32px",
    },
    data() {},
    methods: {},
  },
};
</script>

<style></style>
